import { PayloadAction, createSlice, createSelector } from "@reduxjs/toolkit";
import { ContactInterface } from "interfaces/contact";
import {
  PassengerInfoInterface,
  PassengerInterface,
} from "interfaces/passenger";
import { RootState } from "app/store";

interface PassengerState {
  model: PassengerInterface;
}

const initialState: PassengerState = {
  model: {
    adults: [],
    children: [],
    infants: [],
    contact: {
      countryPrefix: "",
      emailAddress: "",
      phoneNumber: "",
      phoneType: "mobile",
      setHideFileKey: false,
      conditions: false,
    },
  },
};

export const passengerSlice = createSlice({
  name: "passenger",
  initialState,
  reducers: {
    setPaxModel: (state, action) => {
      state.model = action.payload;
    },
    setPassengerModel: (
      state,
      action: PayloadAction<{
        payload: Partial<PassengerInfoInterface>;
        paxType: "adults" | "children" | "infants";
        index: number;
      }>,
    ) => {
      const paxType = action.payload.paxType;
      const index = action.payload.index;

      state.model[paxType][index] = {
        ...state.model[paxType][index],
        ...action.payload.payload,
      };
    },
    setPassengerContact: (
      state,
      action: PayloadAction<Partial<ContactInterface>>,
    ) => {
      state.model.contact = { ...state.model.contact, ...action.payload };
    },
    deleteFqtv: (state) => {
      state.model.adults = state.model.adults.map((adult) => {
        return {
          ...adult,
          fqtvNumber: "",
          fqtvProgram: "",
        };
      });
      state.model.children = state.model.children.map((child) => {
        return {
          ...child,
          fqtvNumber: "",
          fqtvProgram: "",
        };
      });
    },
    cleanDob: (
      state,
      action: PayloadAction<{
        paxType: "children" | "infants" | "adults";
        index: number;
      }>,
    ) => {
      state.model[action.payload.paxType][action.payload.index].dateOfBirth =
        "";
      state.model[action.payload.paxType][action.payload.index].cmpMonth = "";
      state.model[action.payload.paxType][action.payload.index].cmpYear = "";
      state.model[action.payload.paxType][action.payload.index].cmpDate = "";
    },
    resetPaxs: (state) => {
      state.model = initialState.model;
    },
  },
});

export const {
  setPaxModel,
  setPassengerModel,
  setPassengerContact,
  resetPaxs,
  deleteFqtv,
  cleanDob,
} = passengerSlice.actions;

// only called on the passengers screen to get the full passengers list
export const selectPassengerModelFull = (state: RootState) =>
  state.passenger.model;

// get only "clean" passengers, not all the ones in the memory including the ones
// who might have been removed by user reducing the number of passengers
// using createSelector to memoize the result
export const selectPassengerModel = createSelector(
  [selectPassengerModelFull], (passengerModel) => {
    return {
      ...passengerModel,
      adults: passengerModel.adults.filter(adt => adt.traveling),
      infants: passengerModel.infants.filter(inf => inf.traveling),
      children: passengerModel.children.filter(chd => chd.traveling),
    }
  }
)
export default passengerSlice.reducer;
